import React from 'react';
import { PermissionsContext } from './permissions-context';
export const usePermissions = () => {
    return React.useContext(PermissionsContext);
};
//# sourceMappingURL=use-permissions.js.map